import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { PagesProvider } from 'routes/decision-trees/store/PagesContext';

import LiquidityCalculator from 'routes/liquidity-calculator';
import DecisionTrees from 'routes/decision-trees';
import PageNotFound from 'components/PageNotFound';

const App = () => (
  <PagesProvider>
    <BrowserRouter>
      <Routes>
        <Route index path='/' element={<div>Welcome!</div>} />
        <Route path='/liquidity-calculator' element={<LiquidityCalculator />} />
        <Route path='/iso-decision-trees' element={<DecisionTrees startAt={'iso'} />} />
        <Route path='/nso-decision-trees' element={<DecisionTrees startAt={'nso'} />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  </PagesProvider>
);

export default App;
